export default __webpack_public_path__ + "static/media/times-circle.044b676d.svg";